import { Typography } from '@pankod/refine-antd';
import {
  EDiscountEntryType,
  describeLineDiscountEquivalent,
  formatDiscountEntry,
} from 'utilities/discount-entry';

type LineDiscountCellProps = {
  quantity: number;
  unitPrice: number;
  discountCost?: number | null;
  discountEntryValue?: number | null;
  discountEntryType?: EDiscountEntryType | null;
};

// A line discount as entered (10% or TK 100), with its equivalent underneath in small grey text:
// "TK 22.50 each · TK 67.50 total" or "3.57% · TK 300.00 total".
export const LineDiscountCell: React.FC<LineDiscountCellProps> = ({
  quantity,
  unitPrice,
  discountCost,
  discountEntryValue,
  discountEntryType,
}) => {
  const enteredDiscount = formatDiscountEntry(discountEntryValue, discountEntryType, discountCost);
  if (!enteredDiscount) return null;

  const equivalent = describeLineDiscountEquivalent(
    quantity,
    unitPrice,
    discountCost,
    discountEntryValue,
    discountEntryType,
  );

  return (
    <div style={{ lineHeight: 1.3 }}>
      <Typography.Text>{enteredDiscount}</Typography.Text>
      {equivalent && (
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
            {equivalent}
          </Typography.Text>
        </div>
      )}
    </div>
  );
};
